import { Flex, Badge, Tooltip } from "@chakra-ui/react";
import { IconInfo } from "components/icons/Icons";
import { StatusColors } from "../types";

interface StatusColumnProps {
  status: string;
  hasStatusChange: boolean;
}

const getStatusColors = (status: string | null | undefined): StatusColors => {
  if (!status) return { bg: "#D2DAE5", text: "#0B0E10" };

  const lowerStatus = status.toLowerCase();
  if (lowerStatus === "active") return { bg: "#86EFAC", text: "#0B0E10" };
  if (lowerStatus === "completed") return { bg: "#B8D0FF", text: "#1E3A8A" };
  if (lowerStatus === "draft") return { bg: "#D2DAE5", text: "#0B0E10" };
  if (lowerStatus === "revision" || lowerStatus === "review")
    return { bg: "#DBEAFE", text: "#1E40AF" };
  return { bg: "#D2DAE5", text: "#0B0E10" };
};

export const StatusColumn = ({
  status,
  hasStatusChange,
}: StatusColumnProps) => {
  const colors = getStatusColors(status);
  const displayStatus = status || "Draft";

  return (
    <Flex align="center" position="relative" justify="center" w="60px">
      <Badge
        color={colors.text}
        fontSize="14px"
        lineHeight="18px"
        fontWeight="400"
        whiteSpace="nowrap"
        borderRadius="8px"
        p="7px 8px"
        bgColor={colors.bg}
        textTransform="capitalize"
      >
        {displayStatus}
      </Badge>
      {hasStatusChange && (
        <Tooltip label="Order Status has been updated.">
          <IconInfo
            sx={{
              fontSize: "20px",
              position: "absolute",
              right: "-8px",
              top: "-8px",
              bgColor: "#FFF",
              borderRadius: "50%",
              path: {
                fill: "#2F80ED",
              },
            }}
          />
        </Tooltip>
      )}
    </Flex>
  );
};
